module.exports = __webpack_public_path__ + "static/media/pw.39ee4879.png";